var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var Location = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 16 20" }),
        React.createElement("g", null,
            React.createElement("path", { d: "M8,11.5 C6.06700338,11.5 4.5,9.93299662 4.5,8 C4.5,6.06700338 6.06700338,4.5 8,4.5 C9.93299662,4.5 11.5,6.06700338 11.5,8 C11.5,8.92825771 11.1312511,9.81849641 10.4748737,10.4748737 C9.81849641,11.1312511 8.92825771,11.5 8,11.5 L8,11.5 Z M8,5.5 C6.61928813,5.5 5.5,6.61928813 5.5,8 C5.5,9.38071187 6.61928813,10.5 8,10.5 C9.38071187,10.5 10.5,9.38071187 10.5,8 C10.5,7.33695878 10.2366079,6.70107399 9.76776695,6.23223305 C9.29892601,5.7633921 8.66304122,5.5 8,5.5 Z" }),
            React.createElement("path", { d: "M8,19.5 C7.93407285,19.514043 7.86592715,19.514043 7.8,19.5 C0.58,16.37 0.5,8.08 0.5,8 C0.5,3.85786438 3.85786438,0.5 8,0.5 C12.1421356,0.5 15.5,3.85786438 15.5,8 C15.5,8.08 15.44,16.43 8.19,19.46 C8.13078289,19.4883538 8.06562249,19.5020718 8,19.5 L8,19.5 Z M8,1.5 C4.41243253,1.50550664 1.50550664,4.41243253 1.5,8 C1.5,8.08 1.59,15.56 8,18.46 C14.43,15.62 14.5,8.08 14.5,8 C14.4944934,4.41243253 11.5875675,1.50550664 8,1.5 Z" }))));
};
export default Location;
